<style lang="stylus">
.home-act-view
  .float-layer-view
    height 100%
    width 100%
    background rgba(0, 0, 0, .6)
    position fixed
    top 0
    left 0
    z-index 1000
    color rgb(255,255,255)
    display flex
    justify-content center
    align-items center
    .act-view
      position fixed
      top 50%
      left 50%
      @media (max-width: 375px) and (min-width: 320px){
        width calc((302 / 375) * 100vw)
      }
      @media (min-width: 375px){
        width 302px
      }
      transform translate3d(-50%, -50%, 0)
      transition all .1s ease
      .float-img
        width 100%
        display block
        border-radius  6px
      .close-btn
        display block
        margin-top 15px
        width 35px;
        height 35px
        position: absolute;
        left: 50%;
        margin-left: -17.5px;
        background-image: url('~@img/home/iconClose.png')
        background-size: 35px;
  .icon-banner
    z-index 10
    position fixed
    bottom 150px
    right 10px
    display flex
    justify-content: center
    align-items center
    width 50px
    height 50px
    background-size: 50px
    animation icon-scale 3s infinite ease
    transition all .2s ease-out
// 放大缩小动画
.icon-scroll
  opacity 0
.body-active
  overflow-y hidden !important

@keyframes icon-scale {
  0%{
      transform: scale(1);  /*开始为原始大小*/
  }
  25%{
      transform: scale(1.1); /*放大1.1倍*/
  }
  50%{
      transform: scale(1);
  }
  75%{
      transform: scale(1.1);
  }
}
</style>

<template>
  <div v-if="visible" class="home-act-view">
    <div v-show="isHomeFloatBanner" class="float-layer-view">
      <div class="act-view">
        <img :src="floatImgUrl" class="float-img" @click="clickFloatBanner">
        <!-- <img :src="iconClose"  alt="" @click="closeFloat"> -->
        <div class="close-btn" @click="closeFloat"></div>
      </div>
    </div>
    <div v-show="!isHomeFloatBanner" class="icon-banner" :class="{'icon-scroll' : isScrolling}" :style="{'background-image': `url(${iconImgUrl})`}" @click="clickIconBanner">
      <!-- <img :src="iconImgUrl" width="50" height="50" alt="" > -->
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import dayjs from '@app/js/lib/dayjs'
import op from 'object-path'
import {MessageBox, Toast} from 'mint-ui'
import { resolveActionPath } from '../../util/function'
import { os } from '../../util/platform'
const OVERTIME = "00天00时00分00"
export default {
  data() {
    return {
      endTime: 1516261800,
      timer: 0,
      restTime: OVERTIME,
      isScrolling: false,
      iconClose: require('../../../image/home/iconClose.png')
    }
  },
  mounted() {
    const hs = this.handleScroll()
    if (os.isIOS()) {
      window.addEventListener('touchstart', hs)
    }
    window.addEventListener('scroll', hs)
  },
  updated(){
    if(this.isHomeFloatBanner){
      document.getElementsByTagName('body')[0].className='body-active'
    }
  },
  beforeDestroy() {
    const hs = this.handleScroll()
    if (os.isIOS()) {
      window.removeEventListener('touchstart', hs)
    }
    window.removeEventListener('scroll', hs)
  },
  computed: {
    visible() {
      return !_.isEmpty(this.$store.state.activity.act)
    },
    isHomeFloatBanner() {
      return this.$store.state.activity.isHomeFloatBanner
    },
    floatImgUrl() {
      return op(this.$store.state.activity.act.floatBanner).get('imgUrl') || ''
    },
    iconImgUrl() {
      return op(this.$store.state.activity.act).get('imgUrl') || ''
    },
  },
  methods: {
    closeFloat() {
      document.getElementsByTagName('body')[0].className=''
      this.$store.commit('changeIconFloatBanner', {isHomeFloatBanner: false})
    },
    clickIconBanner() {
      document.getElementsByTagName('body')[0].className='body-active'
      this.$store.commit('changeIconFloatBanner', {isHomeFloatBanner: true})
    },
    clickFloatBanner() {
      document.getElementsByTagName('body')[0].className=''
      this.$store.commit('changeIconFloatBanner', {isHomeFloatBanner: false})
      const actInfo = this.$store.state.activity.act
      const path = resolveActionPath({
        actionData: actInfo.actionData,
        actionType: actInfo.actionType,
      })
      this.$router.push(path)
    },
    handleScroll() {
        // 防抖 执行新触发
        let flag = false
        let timeout ;
        return () => {
          this.isScrolling = true
          if(timeout) clearTimeout(timeout)
          timeout = setTimeout(() => {
            this.isScrolling = false
          }, 400)
        }
      },

    // handleScroll() {
    //   const self = this
    //   let flag = 0
    //   let counter = 0
    //   let timer = null
    //   let myTimerFuc = () => {
    //     return setTimeout(((preflag) => () => {
    //       if (preflag !== flag) {
    //         timer = myTimerFuc()
    //         return
    //       }
    //       flag = 0
    //       clearTimeout(timer)
    //       timer = null
    //       self.isScrolling = false
    //     })(flag), 400)
    //   }
    //   return _.throttle(() => {
    //     self.isScrolling = true
    //     flag ++
    //     if (timer) {
    //       return
    //     }
    //     timer = myTimerFuc()
    //   }, 100)
    // },
  },
}
</script>

